import { ExclamationCircleFilled } from "@ant-design/icons";
import { VideoCard } from "Admin/Components";
import { video_grid } from "Admin/Config/Grid";
import { IconPack } from "Admin/Config/Icon";
import {
  addProfileVideo,
  deleteProfileVideo,
  getProfileVideo,
} from "Admin/Service/Profile";
import { Button, Input, List, message, Modal } from "antd";
import { useEffect, useState } from "react";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
import styles from "./Videos.module.scss";
const { confirm } = Modal;
const Videos = () => {
  const [data, setData] = useState({ data: null, isLoading: true });
  const [openAddVideoModal, setOpenAddVideoModal] = useState(false);
  const [openDeleteVideoModal, setOpenDeleteVideoModal] = useState(false);
  const [newLink, setNewLink] = useState("");
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileVideo((res) => {
      handleAPIResponse(res, () => {
        setData({
          data: res.data.video_presentations,
          isLoading: false,
        });
      });
    });
  }, []);
  const handleDeleteVideo = (record) => {
    const payload = {
      link: record,
    };
    confirm({
      title: "Are you sure delete this video?",
      icon: <ExclamationCircleFilled />,
      content: "This action is irreversible.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      open: openDeleteVideoModal,
      onOk() {
        deleteProfileVideo(payload, (res) => {
          handleAPIResponse(res, () => {
            const updateList = data.data.filter((item) => item !== record);
            setData({ data: updateList, isLoading: false });
            message.success("Delete video successfully");
            setOpenDeleteVideoModal(false);
          });
        });
      },
      onCancel() {
        setOpenDeleteVideoModal(false);
      },
    });
  };

  const handleAddVideo = () => {
    const payload = {
      links: [newLink],
    };
    addProfileVideo(payload, (res) => {
      handleAPIResponse(res, () => {
        message.success("Add video successfully");
        setOpenAddVideoModal(false);
        setData({
          data: [newLink, ...data.data],
          isLoading: false,
        });
      });
    });
  };

  const ProfileVideoCard = ({ link }) => {
    return (
      <div className={styles["profile-video-card"]}>
        <VideoCard videoUrl={link} />
        <div
          className={styles["delete-video"]}
          onClick={() => handleDeleteVideo(link)}
        >
          {IconPack.delete_icon}
        </div>
      </div>
    );
  };
  return (
    <div className={styles["videos"]}>
      <Modal
        title="Basic Modal"
        open={openAddVideoModal}
        onOk={handleAddVideo}
        width={1000}
        onCancel={() => setOpenAddVideoModal(false)}
      >
        <p>Video link:</p>
        <Input onChange={(value) => setNewLink(value.target.value)} />
      </Modal>
      <div className={styles["add-button"]}>
        <Button type="primary" onClick={() => setOpenAddVideoModal(true)}>
          Add video
        </Button>
      </div>

      <div className={styles["content-video"]}>
        <List
          grid={video_grid}
          dataSource={data.data?.length > 0 ? data.data : []}
          renderItem={(item, index) => {
            return (
              <List.Item key={index}>
                <ProfileVideoCard link={item} />
              </List.Item>
            );
          }}
        />
      </div>
    </div>
  );
};

export default Videos;
